const statusStyles = {
  // General
  active: 'bg-emerald-100 text-emerald-700',
  onboarding: 'bg-blue-100 text-blue-700',
  suspended: 'bg-red-100 text-red-700',
  terminated: 'bg-gray-200 text-gray-600',

  // Compliance
  current: 'bg-emerald-100 text-emerald-700',
  expiring_soon: 'bg-amber-100 text-amber-700',
  expired: 'bg-red-100 text-red-700',
  pending: 'bg-gray-100 text-gray-600',
  waived: 'bg-purple-100 text-purple-700',

  // Observations / Reviews
  draft: 'bg-gray-100 text-gray-600',
  submitted: 'bg-blue-100 text-blue-700',
  acknowledged: 'bg-amber-100 text-amber-700',
  verified: 'bg-emerald-100 text-emerald-700',
  staff_reviewed: 'bg-amber-100 text-amber-700',
  finalized: 'bg-emerald-100 text-emerald-700',

  // Tasks
  open: 'bg-blue-100 text-blue-700',
  in_progress: 'bg-amber-100 text-amber-700',
  pending_verification: 'bg-purple-100 text-purple-700',
  complete: 'bg-emerald-100 text-emerald-700',

  // Recruitment
  application_received: 'bg-violet-100 text-violet-700',
  interview_scheduled: 'bg-blue-100 text-blue-700',
  pre_interview: 'bg-indigo-100 text-indigo-700',
  interview_conducted: 'bg-amber-100 text-amber-700',
  hire_decision: 'bg-purple-100 text-purple-700',
  offer_letter: 'bg-teal-100 text-teal-700',
  hired: 'bg-emerald-100 text-emerald-700',
  no_hire: 'bg-red-100 text-red-700',
  talent_pool: 'bg-cyan-100 text-cyan-700',

  // Onboarding
  completed: 'bg-amber-100 text-amber-700',

  // 1:1
  scheduled: 'bg-blue-100 text-blue-700',
  conducted: 'bg-amber-100 text-amber-700',
  staff_verified: 'bg-amber-100 text-amber-700',
  fully_verified: 'bg-emerald-100 text-emerald-700',

  // Priority
  high: 'bg-red-100 text-red-700',
  medium: 'bg-amber-100 text-amber-700',
  low: 'bg-green-100 text-green-700',

  // Tiers
  licensing_critical: 'bg-red-100 text-red-700',
  standard: 'bg-blue-100 text-blue-700',
};

const labelMap = {
  application_received: 'Application Received',
  interview_scheduled: 'Interview Scheduled',
  pre_interview: 'Pre-Interview',
  interview_conducted: 'Interview Done',
  hire_decision: 'Hire Decision',
  offer_letter: 'Offer Letter',
  no_hire: 'No Hire',
  talent_pool: 'Talent Pool',
  expiring_soon: 'Expiring Soon',
  pending_verification: 'Pending Verification',
  in_progress: 'In Progress',
  lead_admin: 'Lead Admin',
  staff_reviewed: 'Staff Reviewed',
  staff_verified: 'Staff Verified',
  fully_verified: 'Fully Verified',
  licensing_critical: 'Licensing Critical',
  verbal_warning: 'Verbal Warning',
  written_warning: 'Written Warning',
  performance_improvement_plan: 'PIP',
  director_action: 'Director Action',
};

export default function StatusBadge({ status, className = '' }) {
  const style = statusStyles[status] || 'bg-gray-100 text-gray-600';
  const label = labelMap[status] || status?.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style} ${className}`}>
      {label}
    </span>
  );
}
